import { apiClient, ApiResponse } from './apiClient';
import { CreatorStore, UpdateCreatorStoreData } from '../types/creatorStore.types';

/**
 * Creator Store Service
 * Handles business profile management for creator accounts
 */

export const storeService = {
  /**
   * Get my store settings
   * GET /store/settings
   * Auth Required: Yes (Creator only)
   */
  getMyStore: async (): Promise<ApiResponse<{ store: CreatorStore }>> => {
    return await apiClient.get<{ store: CreatorStore }>('/store/settings');
  },

  /**
   * Update my store settings
   * PATCH /store/settings
   * Auth Required: Yes (Creator only)
   * Supports both JSON and FormData (for logo upload)
   */
  updateStore: async (data: UpdateCreatorStoreData): Promise<ApiResponse<{ store: CreatorStore }>> => {
    // If logo file is provided, use FormData
    if (data.logo) {
      const formData = new FormData();
      
      if (data.businessName) formData.append('businessName', data.businessName);
      if (data.description) formData.append('description', data.description);
      if (data.contactEmail) formData.append('contactEmail', data.contactEmail);
      if (data.contactPhone) formData.append('contactPhone', data.contactPhone);
      if (data.businessAddress) formData.append('businessAddress', data.businessAddress);
      if (data.returnPolicy) formData.append('returnPolicy', data.returnPolicy);
      if (data.shippingPolicy) formData.append('shippingPolicy', data.shippingPolicy);
      if (data.termsAndConditions) formData.append('termsAndConditions', data.termsAndConditions);
      if (data.currency) formData.append('currency', data.currency);
      if (data.settings) formData.append('settings', JSON.stringify(data.settings));
      formData.append('logo', data.logo);

      return await apiClient.uploadFile<{ store: CreatorStore }>('/store/settings', formData, 'PATCH');
    }

    // Otherwise, use JSON
    const { logo, ...jsonData } = data;
    return await apiClient.patch<{ store: CreatorStore }>('/store/settings', jsonData);
  },

  /**
   * Get public store info
   * GET /store/user/:userId
   * Auth Required: No
   */
  getPublicStore: async (userId: string): Promise<ApiResponse<{ store: CreatorStore }>> => {
    return await apiClient.get<{ store: CreatorStore }>(`/store/user/${userId}`);
  },
};
